import React, { Fragment } from "react";
import "./Navbar.css";

const mailDetails = {
  email: "gauravsachar29@gmail.com",
  subject: "Interested in your profile.",
  body: "Hello! Gaurav, We loved your profile...",
};

const Contact = () => {
  return (
    <Fragment>
      <div className="introPage">
        <div className="aboutSection contactSection" id="Contact">
          <h5 className="aboutHead">Contact</h5>
          <div className="aboutContent">
            <p style={{ textAlign: "center" }}>
              If you've found anything intersing here or just wanna have some
              technical chitchat, feel free to drop a mail. I'll try my best to
              answer.
            </p>
            <div className="konnichiwa">
              <a
                className="githubNav clHello"
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${mailDetails.email}&cc=sachargaurav123.ils@gmail.com&su=${mailDetails.subject}&body=${mailDetails.body}`}
                target="_blank"
                rel="noreferrer"
              >
                こんにちわ
              </a>
            </div>
            <div className="box">
              <hr />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Contact;
